module.exports = __webpack_public_path__ + "img/tamga.c9548b03.png";